import { useI18n } from 'next-localization';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import styles from './styles/SkipToMainContent.module.scss';
import { useRef } from 'react';

const SkipToMainContent = () => {
  const { t } = useI18n();
  const { sitecoreContext } = useSitecoreContext();
  const isHeaderPresent = sitecoreContext.route?.placeholders['abrdn-header']?.length;
  const skippToMainContentRef = useRef();
  if (!isHeaderPresent) return null;

  const mainContent = typeof document !== 'undefined' && document.getElementById('main-content');
  const scrollToMainContent = (e) => {
    if (e.code === 'Space' || e.code === 'Enter') {
      e.preventDefault();
      mainContent.scrollIntoView();
      skippToMainContentRef.current?.blur();
    }
  };

  return (
    <div className={styles['skip-to-main-content']}>
      <div className="container">
        <a
          ref={skippToMainContentRef}
          href="#"
          onKeyDown={scrollToMainContent}
          className="text-link"
        >
          {t('skipToMainContent')}
        </a>
      </div>
    </div>
  );
};

export default SkipToMainContent;
